module.exports = __webpack_public_path__ + "img/Jamaica.24af1884.gif";